<template>
  <f7-app :params="f7params">
    <leftPanel
      v-if="canAccessApp"
      :elements="opcionesMenu"
      :version="version"
    />
    <f7-view
      v-if="canAccessApp"
      main
      resizable
      class="safe-areas"
      url="/"
    />
  </f7-app>
</template>
<script>

import { Device } from 'framework7/framework7-lite.esm.bundle';
import { mapActions, mapState, mapMutations } from 'vuex';
import esMessages from 'devextreme/localization/messages/es.json';
import { locale, loadMessages } from 'devextreme/localization';
import grMessages from '../json/translations/devExtremeMessages/gr.json';
import arMessages from '../json/translations/devExtremeMessages/ar.json';
import { APP_VERSION } from '../js/constants';
import cordovaApp from '../js/cordova-app';
import store from '../store/index';
import routes from '../js/routes';
import leftPanel from './LeftPanel.vue';
import opcionesMenu from '../json/menuList.json';
import EventBus from '../js/event-bus';

export default {
  components: {
    leftPanel,
  },
  store,
  data() {
    return {
      version: APP_VERSION,
      opcionesMenu,
      showToDefault: true,
      // Framework7 Parameters
      f7params: {
        id: 'es.hispatec.mopeco', // App bundle ID
        name: 'Mopeco', // App name
        theme: 'auto', // Automatic theme detection

        // App routes
        routes,
        // Input settings
        input: {
          scrollIntoViewOnFocus: Device.cordova && !Device.electron,
          scrollIntoViewCentered: Device.cordova && !Device.electron,
        },

        // Cordova Statusbar settings
        statusbar: {
          iosOverlaysWebView: true,
          androidOverlaysWebView: false,
          androidTextColor: 'white',
          androidBackgroundColor: '#000000',
          iosTextColor: 'white',
          iosBackgroundColor: '#000000',
        },
      },
      // Login screen data
      username: '',
      password: '',
    };
  },
  computed: {
    loginNeeded() {
      return false;
    },
    canAccessApp() {
      return true;
    },
    requestNewPasssword() {
      return (this.loggedUser == null && this.wantToRecoveryPass === true);
    },
    ...mapState('authentication', [
      'activationCode',
      'loggedUser',
      'appConfig',
      'wantToRemember',
      'wantToRecoveryPass',
      'changePassword',
      'messageChangePassword',
    ]),
  },
  created() {
    loadMessages(esMessages);
    loadMessages(arMessages);
    loadMessages(grMessages);
  },
  mounted() {
    this.$f7ready((f7) => {
      // Init cordova APIs (see cordova-app.js)
      if (Device.cordova) {
        cordovaApp.init(f7);
      }

      this.updateLanguage(store.state.authentication.languageSelected);
      EventBus.$on('change-language', this.updateLanguage);
    });
  },
  methods: {
    updateLanguage(newLanguage) {
      this.$i18n.locale = newLanguage;
      locale(newLanguage);
    },
    ...mapActions('authentication', ['activateApp', 'deactivateApp', 'logout']),
    ...mapActions('AccessControl', ['scan']),
    ...mapMutations('authentication', ['setMessageChangePassword']),
  },
};
</script>
